import React, { useEffect, useMemo, useState } from "react";
import { AdminLayout } from "../../layouts";
import { Box, IconButton, Menu, MenuItem, Paper, Typography, Container, Chip, Grid, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, CircularProgress, FormControl, InputLabel, Select, FormHelperText, Autocomplete } from '@mui/material';
import { MoreVert } from "@mui/icons-material";
import { DataGrid, GridToolbar, GridRowsProp, GridColDef, GridFilterModel, GridColumnVisibilityModel, GridRenderCellParams, GridCellParams } from '@mui/x-data-grid';
import { getEstudiantesAdmin, putEstudiante, getColegiosAdmin, deleteEstudiante } from "../../api/providers";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import { showAlert } from "../../helpers/alerts";

export const StudentsPage = () => {
    const token: string | undefined = Cookies.get("token");

    const RowMenu = ({ row, handleDeleteStudent }: any) => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: any) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <>
                <IconButton
                    aria-label="more"
                    id={`long-button-${row.id}`}
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVert />
                </IconButton>
                <Menu
                    id={`long-menu-${row.id}`}
                    MenuListProps={{
                        'aria-labelledby': `long-button-${row.id}`,
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => handleOpenEditDialog(row)}>Editar Estudiante</MenuItem>
                    <MenuItem onClick={() => handleDeleteStudent(row)}>Eliminar Estudiante</MenuItem>
                    {/* <MenuItem onClick={handleClose}>Eliminar Estudiante(Pronto)</MenuItem> */}
                    {/* <MenuItem onClick={handleClose}>Ver Cursos Inscritos(Pronto)</MenuItem> */}
                </Menu>
            </>
        );
    };



    const columns: GridColDef[] = useMemo(() => [
        //ACCIONES
        {
            field: 'actions', headerName: '', width: 50,
            renderCell: (params) => <RowMenu row={params.row} handleDeleteStudent={handleDeleteStudent} />,
        },
        //DATOS DEL ESTUDIANTE
        { field: 'nombre', headerName: 'Nombre', width: 130, headerClassName: 'datos-estudiante' },
        { field: 'primerApellido', headerName: 'Primer Apellido', width: 130, headerClassName: 'datos-estudiante' },
        { field: 'segundoApellido', headerName: 'Segundo Apellido', width: 130, headerClassName: 'datos-estudiante' },
        {
            field: 'telefono',
            headerClassName: 'datos-estudiante',
            headerName: 'Teléfono Estudiante',
            width: 175,
            type: 'string',
            renderCell: (params: GridCellParams) => {
                const telefono = params.value as string ?? "";
                const codigoPais = telefono.substring(0, 4); // "+506"
                const restoNumero = telefono.substring(4); // El resto del número
                const numeroFormateado = `${restoNumero.slice(0, 4)}-${restoNumero.slice(4)}`; // Agregar guion

                return (
                    <Chip
                        label={codigoPais + " " + numeroFormateado}
                        sx={{
                            width: "100%",
                            backgroundColor: "#D3E4F5",
                            fontWeight: "bold",
                            fontSize: "0.9rem",
                            color: "#233367", // Azul oscuro para el texto
                            borderRadius: 1,
                        }} />);
            },
        },
        { field: 'correo', headerName: 'Correo', width: 175, headerClassName: 'datos-estudiante' },
        {
            field: 'tipoCedula', headerClassName: 'datos-estudiante',
            headerName: 'Tipo de cedula',
            width: 130,
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as string}
                    sx={{
                        backgroundColor: params.value === "Fisica" ? "#64B5F6" :
                            params.value === "Juridica" ? "#F06292" :
                                params.value === "DIMEX" ? "#BA68C8 " :
                                    params.value === "NITE" ? "#FFA726 " :
                                        params.value === "Extranjero" ? "#4DB6AC" :
                                            "grey",
                        color: "white",
                        borderRadius: 1,
                        width: "100%",
                        fontWeight: "bold",
                        fontSize: "1rem",
                    }}
                />
            ),
        },
        { field: 'cedula', headerName: 'Cedula', width: 130, headerClassName: 'datos-estudiante' },
        {
            field: 'condicionEscolar', headerName: 'Condicion Escolar', width: 150, headerClassName: 'datos-estudiante',
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as string}
                    sx={{
                        backgroundColor: params.value === "activo" ? "secondary.dark" : // Verde para activo
                            params.value === "egresado" ? "primary.light" : "grey", // Rojo para inactivo
                        color: "white", // Texto en blanco para mejor visibilidad
                        borderRadius: 1, // Bordes redondeados
                        width: "100%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem", // Tamaño de fuente más pequeño
                    }} />),
        },
        { field: 'colegio', headerName: 'Colegio', width: 150, headerClassName: 'datos-estudiante' },
        { field: 'colegioProvincia', headerName: 'Provincia del Colegio', width: 150, headerClassName: 'datos-estudiante' },
        {
            field: 'inscripciones', headerName: 'Cursos inscritos', align: 'center', width: 130,
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as number}
                    sx={{
                        backgroundColor: "#9E9E9E", // Rojo para inactivo
                        color: "white", // Texto en blanco para mejor visibilidad
                        borderRadius: 1, // Bordes redondeados
                        width: "100%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem", // Tamaño de fuente más pequeño
                    }} />),
        },
        { field: 'nombreEncargado', headerName: 'Nombre del Encargado', width: 175, headerClassName: 'datos-encargado' },
        { field: 'correoEncargado', headerName: 'Correo del Encargado', width: 175, headerClassName: 'datos-encargado' },
        {
            field: 'telefonoEncargado', headerName: 'Telefono del Encargado', width: 175, headerClassName: 'datos-encargado',
            renderCell: (params: GridCellParams) => {
                const telefono = params.value as string ?? "";
                const codigoPais = telefono.substring(0, 4); // "+506"
                const restoNumero = telefono.substring(4); // El resto del número
                const numeroFormateado = `${restoNumero.slice(0, 4)}-${restoNumero.slice(4)}`; // Agregar guion

                return (
                    <Chip
                        label={codigoPais + " " + numeroFormateado}
                        sx={{
                            width: "100%",
                            backgroundColor: "#D3E4F5",
                            fontWeight: "bold",
                            fontSize: "0.9rem",
                            color: "#233367", // Azul oscuro para el texto
                            borderRadius: 1,
                        }} />);
            },
        },
        //DATOS DE CREACION Y ACTUALIZACION
        { field: 'createdAt', headerName: 'Fecha de registro', width: 130, type: 'date' },
        { field: 'updatedAt', headerName: 'Ultima edicion', width: 120, type: 'date' },
    ], []);

    const [students, setStudents] = useState<any>([]);
    const [colegios, setColegios] = useState<any>([]);
    const [loading, setLoading] = useState<any>(true);
    const [error, setError] = useState<any>(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editData, setEditData] = useState({});
    const [originalData, setOriginalData] = useState({});

    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        formState: { errors: errorsEdit },
        reset: resetEdit,
        setValue: setValueEdit,
        watch
    } = useForm();

    const fetchData = async () => {
        const token: any = Cookies.get("token");
        setLoading(true);

        // Fetch estudiantes
        const estudiantesResponse = await getEstudiantesAdmin(token);
        if (!estudiantesResponse.ok) {
            setError('No se pudo cargar los estudiantes');
            setStudents([]);
        } else {
            const estudiantesTransformados = estudiantesResponse.estudiantes.estudiantes.map((estudiante: any) => ({
                ...estudiante,
                createdAt: new Date(estudiante.createdAt.split("Z")[0]),
                updatedAt: new Date(estudiante.updatedAt.split("Z")[0]),
            }));
            setStudents(estudiantesTransformados);
        }

        // Fetch colegios
        const colegiosResponse = await getColegiosAdmin(token);
        if (!colegiosResponse.ok) {
            setError('No se pudo cargar los colegios');
            setColegios([]);
        } else {

            setColegios(colegiosResponse.colegios.colegios);
        }

        setLoading(false);
    };

    useEffect(() => {


        fetchData();
    }, []);

    const handleDeleteStudent = async (selectedStudent: any) => {
        try {
            console.log(selectedStudent);
            const response = await deleteEstudiante(token!, selectedStudent.id);
            if (!response.ok) {
                showAlert('Error', response.errorMessage.error, 'error');

                throw new Error('Error al eliminar estudiante');
            }
            showAlert('¡Éxito!', 'Estudiante eliminado exitosamente', 'success');
            fetchData();
        } catch (error: any) {
            showAlert('Error', error.message, 'error');

        }
    };

    const rows: GridRowsProp = students;

    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });

    const [columnVisibilityModel, setColumnVisibilityModel] =
        React.useState<GridColumnVisibilityModel>({
            tipoCedula: false, // Oculta la columna "Tipo de cédula"
            inscripciones: false, // Oculta la columna "Cursos inscritos"
            createdAt: false, // Oculta la columna "Fecha de registro"
            updatedAt: false, // Oculta la columna "Ultima edición"
        });

    const handleOpenEditDialog = (row: any) => {
        setEditData(row);
        setOriginalData(row);
        resetEdit(row);
        setValueEdit("colegioId", row.colegioId); // Set the initial value for the colegio field
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
    };


    const handleSaveEdit = handleSubmitEdit(async (data) => {

        // const modifiedData = Object.keys(data).reduce((acc, key) => {
        //     if (data[key] !== originalData[key]) {
        //         acc[key] = data[key];
        //     }
        //     return acc;
        // }, {});

        // // await putEstudiante(token, { id: originalData.id,...modifiedData });
        setLoading(true);
        const token: any = Cookies.get("token");

        try {
            // Enviar la solicitud para editar el estudiante
            const estudianteUpdated = await putEstudiante(token, data);

            if (!estudianteUpdated.ok) {
                // Mostrar alerta de error reutilizando el helper
                showAlert('Error', estudianteUpdated.errorMessage.error, 'error');
            } else {
                // Mostrar alerta de éxito reutilizando el helper
                showAlert('¡Éxito!', 'El estudiante ha sido actualizado correctamente.', 'success');
            }
        } catch (error) {
            console.error(error);
            // Mostrar alerta genérica de error reutilizando el helper
            showAlert('Error', 'Ocurrió un error inesperado al procesar la solicitud.', 'error');
        } finally {
            try {
                // Intentar siempre cargar los estudiantes actualizados
                const response = await getEstudiantesAdmin(token);

                if (!response.ok) {
                    setError('No se pudo cargar los estudiantes');
                    setStudents([]);
                } else {
                    const estudiantesTransformados = response.estudiantes.estudiantes.map((estudiante: any) => ({
                        ...estudiante,
                        createdAt: new Date(estudiante.createdAt.split("Z")[0]),
                        updatedAt: new Date(estudiante.updatedAt.split("Z")[0]),
                    }));
                    setStudents(estudiantesTransformados);
                }
            } catch (error) {
                console.error('Error al cargar los estudiantes:', error);
                setError('No se pudo cargar los estudiantes');
                setStudents([]);
            } finally {
                setLoading(false);
                handleCloseEditDialog();
            }
        }
    });


    return (
        <AdminLayout title='Estudiantes'>
            <>
                {loading ? <LoadingScreen /> :
                    error ? <div>Error: {error}</div>
                        : <Paper sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 0, p: 2 }}>
                            <Grid item xs={12} container alignItems="center" justifyContent="space-between" mb={1}>
                                <Box>
                                    <Typography fontSize={22} component="div" align="left">
                                        Listado de estudiantes
                                    </Typography>
                                </Box>
                            </Grid>
                            <Box sx={{ height: '85vh' }}>
                                <DataGrid
                                    columns={columns}
                                    rows={rows}
                                    sx={{ padding: "10px" }}
                                    slots={{ toolbar: GridToolbar }}
                                    filterModel={filterModel}
                                    onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                        },
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel) =>
                                        setColumnVisibilityModel(newModel)
                                    }
                                />
                            </Box>
                        </Paper>
                }

                {/* Dialog for Editing Student */}
                <Dialog
                    open={openEditDialog}
                    onClose={handleCloseEditDialog}
                    fullWidth
                    maxWidth="md"
                >
                    <form onSubmit={handleSaveEdit}>
                        <DialogTitle
                            sx={{
                                fontWeight: "bold",
                                fontSize: "2rem",
                                color: "secondary.dark",

                            }}>
                            Editar Estudiante</DialogTitle>
                        <DialogContent>
                            <Typography sx={{

                                marginBottom: 2,
                                borderBottom: "2px solid #ccc",
                                paddingBottom: 1,
                                color: "primary.light",
                            }} variant="h6" gutterBottom>
                                Información del Estudiante
                            </Typography>
                            <Grid container spacing={2}>

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="nombre"
                                        label="Nombre"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("nombre", {})}
                                        error={Boolean(errorsEdit.nombre)}
                                        helperText={errorsEdit.nombre?.message}
                                    />

                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <TextField
                                        margin="dense"
                                        id="primerApellido"
                                        label="Primer Apellido"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("primerApellido", {})}
                                        error={Boolean(errorsEdit.primerApellido)}
                                        helperText={errorsEdit.primerApellido?.message}
                                    />

                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <TextField
                                        margin="dense"
                                        id="segundoApellido"
                                        label="Segundo Apellido"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("segundoApellido", {})}
                                        error={Boolean(errorsEdit.segundoApellido)}
                                        helperText={errorsEdit.segundoApellido?.message}
                                    />

                                </Grid>

                                <Grid item xs={12} md={3}>

                                    <FormControl fullWidth error={!!errorsEdit.cedula} variant='outlined' margin="dense">
                                        <InputLabel id="cedula-label">Tipo de Cédula</InputLabel>
                                        <Select
                                            labelId="cedula-label"
                                            id="cedula-select"
                                            label="cedula escolar"
                                            {...registerEdit("tipoCedula", {})}
                                            value={watch("tipoCedula")}
                                        >
                                            <MenuItem value="Fisica">Persona Física</MenuItem>
                                            <MenuItem value="Juridica">Persona Jurídica</MenuItem>
                                            <MenuItem value="DIMEX">DIMEX</MenuItem>
                                            <MenuItem value="NITE">NITE</MenuItem>
                                            <MenuItem value="Extranjero">Extranjero(Fuera CR)</MenuItem>
                                        </Select>
                                        <FormHelperText>{errorsEdit.cedula?.message}</FormHelperText>
                                    </FormControl>

                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <TextField
                                        margin="dense"
                                        id="cedula"
                                        label="Cédula"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("cedula", {})}
                                        error={Boolean(errorsEdit.cedula)}
                                        helperText={errorsEdit.cedula?.message}
                                    />

                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        margin="dense"
                                        id="telefono"
                                        label="Teléfono"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("telefono", {})}
                                        error={Boolean(errorsEdit.telefono)}
                                        helperText={errorsEdit.telefono?.message}
                                    />


                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        margin="dense"
                                        id="correo"
                                        label="Correo"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("correo", {})}
                                        error={Boolean(errorsEdit.correo)}
                                        helperText={errorsEdit.correo?.message}
                                    />


                                </Grid>
                                <Grid item xs={12} md={3}>

                                    <FormControl fullWidth error={Boolean(errorsEdit.condicionEscolar)} variant='outlined' margin="dense">
                                        <InputLabel id="condicion-label">Condición Escolar</InputLabel>
                                        <Select
                                            labelId="condicion-label"
                                            id="condicion-select"
                                            label="Condición Escolar"
                                            {...registerEdit("condicionEscolar", {})}
                                            value={watch("condicionEscolar")}
                                            onChange={(e) => {
                                                setValueEdit("condicionEscolar", e.target.value, { shouldValidate: true });
                                            }}
                                        >
                                            <MenuItem value="activo">Activo</MenuItem>
                                            <MenuItem value="egresado">Egresado</MenuItem>
                                        </Select>
                                        <FormHelperText>{errorsEdit.condicionEscolar?.message}</FormHelperText>
                                    </FormControl>



                                </Grid>



                                <Grid item xs={12} md={5}>
                                    <FormControl fullWidth error={Boolean(errorsEdit.colegio)} variant='outlined' margin="dense">
                                        <Autocomplete
                                            id="colegio-autocomplete"
                                            options={colegios}
                                            getOptionLabel={(option) => `${option.nombre}`}
                                            value={colegios.find((colegio: any) => colegio.id === watch("colegioId")) || null}
                                            onChange={(event, newValue) => {
                                                setValueEdit("colegioId", newValue ? newValue.id : null);
                                                setValueEdit("colegioProvincia", newValue ? newValue.provincia : null)
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Colegio del estudiante"
                                                    variant="outlined"
                                                    error={Boolean(errorsEdit.colegio)}
                                                    helperText={errorsEdit.colegio?.message}
                                                />
                                            )}
                                        />
                                    </FormControl>


                                </Grid>

                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        id="colegioProvincia"
                                        label="Provincia del Colegio"
                                        fullWidth
                                        variant="filled"
                                        value={watch("colegioProvincia") || ""} // Mostrar la provincia seleccionada
                                        disabled
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <Typography sx={{

                                        marginBottom: 2,
                                        borderBottom: "2px solid #ccc",
                                        paddingBottom: 1,
                                        color: "primary.light",
                                    }} variant="h6" gutterBottom>
                                        Información del Encargado
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        margin="dense"
                                        id="nombreEncargado"
                                        label="Nombre del Encargado"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("nombreEncargado", {})}
                                        error={Boolean(errorsEdit.nombreEncargado)}
                                        helperText={errorsEdit.nombreEncargado?.message}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        margin="dense"
                                        id="telefonoEncargado"
                                        label="Teléfono del Encargado"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("telefonoEncargado", {})}
                                        error={Boolean(errorsEdit.telefonoEncargado)}
                                        helperText={errorsEdit.telefonoEncargado?.message}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        margin="dense"
                                        id="correoEncargado"
                                        label="Correo del Encargado"
                                        fullWidth
                                        variant="outlined"
                                        {...registerEdit("correoEncargado", {})}
                                        error={Boolean(errorsEdit.correoEncargado)}
                                        helperText={errorsEdit.correoEncargado?.message}
                                    />
                                </Grid>


                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseEditDialog} color="error">Cancelar</Button>
                            <Button type="submit" color="primary">{loading ? <CircularProgress /> : "Guardar"}</Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </>
        </AdminLayout>
    );
};